import React, { useState } from "react";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import * as yup from "yup";
import PropTypes from "prop-types";

import { changeUserPassword } from "../actions/user";

import Loading from "../components/Loading";
import LabeledFormField from "../components/LabeledFormField";
import { PageContainer } from "../styles/common";
import Button from "../components/Button";

function ChangePassword(props) {
  const [showLoader, setShowLoader] = useState(false);
  const [passwordChanged, handlePasswordChanged] = useState(false);
  const validationSchema = yup.object().shape({
    password: yup.string().required("Current password is required"),
    newPassword: yup.string().required("New password is required"),
    newPasswordConfirm: yup
      .string()
      .required("Please confirm new the password"),
  });
  async function onSubmit(values, actions) {
    try {
      setShowLoader(true);
      let res = await props.changeUserPassword(values);
      setShowLoader(false);
      if (res?.error?.response?.data?.response) {
        const errors = res.error.response.data.response.errors;
        actions.setErrors({
          password: errors.password,
          newPassword: errors.new_password,
          newPasswordConfirm: errors.new_password_confirm,
        });
        return;
      }
      handlePasswordChanged(true);
    } catch (e) {
      setShowLoader(false);
    }
  }

  if (passwordChanged) {
    return (
      <PageContainer>
        <div className="max-w-7xl w-full px-4 sm:px-6 lg:px-8 mt-3">
          <div className="max-w-xl mx-auto">
            <h1 className="text-2xl mb-3">Password changed successfully</h1>
          </div>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <div className="max-w-7xl w-full px-4 sm:px-6 lg:px-8 mt-3">
        <div className="max-w-xl mx-auto">
          <h1 className="text-2xl mb-3">Change Password</h1>
          <Formik
            initialValues={{
              password: "",
              newPassword: "",
              newPasswordConfirm: "",
            }}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            validate={(values) => {
              const errors = {};
              if (
                values.newPasswordConfirm &&
                values.newPassword !== values.newPasswordConfirm
              ) {
                errors.newPasswordConfirm = "Password mismatch";
              }
              return errors;
            }}
          >
            {({ isValid, isSubmitting }) => (
              <Form>
                <LabeledFormField
                  label="Password"
                  type="password"
                  name="password"
                  tabIndex="1"
                />
                <LabeledFormField
                  label="New Password"
                  type="password"
                  name="newPassword"
                  tabIndex="1"
                />
                <LabeledFormField
                  label="Confirm Password"
                  type="password"
                  name="newPasswordConfirm"
                  tabIndex="1"
                />
                <Button
                  intent="link"
                  className="mt-2"
                  type="submit"
                  disabled={isSubmitting || showLoader}
                >
                  Change Password
                  {showLoader && (
                    <div className="text-center ml-1 relative top-1">
                      <Loading />
                    </div>
                  )}
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </PageContainer>
  );
}
ChangePassword.propTypes = {
  changeUserPassword: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  changeUserPassword: ({ password, newPassword, newPasswordConfirm }) =>
    dispatch(changeUserPassword(password, newPassword, newPasswordConfirm)),
});

export default connect(null, mapDispatchToProps)(ChangePassword);
